var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.9987 14.6673C11.6806 14.6673 14.6654 11.6825 14.6654 8.00065C14.6654 4.31875 11.6806 1.33398 7.9987 1.33398C4.3168 1.33398 1.33203 4.31875 1.33203 8.00065C1.33203 11.6825 4.3168 14.6673 7.9987 14.6673Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4751 10.6192C10.3884 10.6192 10.3017 10.5992 10.2217 10.5459L8.15505 9.31253C7.64172 9.00586 7.26172 8.33253 7.26172 7.73919V5.00586C7.26172 4.73253 7.48839 4.50586 7.76172 4.50586C8.03505 4.50586 8.26172 4.73253 8.26172 5.00586V7.73919C8.26172 7.97919 8.46172 8.33253 8.66839 8.45253L10.7351 9.68586C10.9751 9.82586 11.0484 10.1325 10.9084 10.3725C10.8084 10.5325 10.6417 10.6192 10.4751 10.6192Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerColor);
export default __webpack_public_path__ + "static/media/timer_color.be950285ae22555a3cc02722bba0eb09.svg";
export { ForwardRef as ReactComponent };